import { render, staticRenderFns } from "./vueperslide.vue?vue&type=template&id=5119b09a&lang=pug&"
import script from "./vueperslide.vue?vue&type=script&lang=js&"
export * from "./vueperslide.vue?vue&type=script&lang=js&"
import style0 from "./vueperslide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports